import { Button } from '@wot/components';
import React, { SetStateAction, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import authApi from '../../api/auth';
import { APPLE_ICON, GOOGLE_ICON } from '../../assets/icons';
import OtpScreen from './OtpScreen';
import { toast } from 'react-toastify';
import { login } from '../../reducers/authSlice';
import { useAppDispatch } from '../../hooks/useRedux';

interface IloginStep {
  setStep: React.Dispatch<SetStateAction<number>>;
}

const EmailScreen: React.FC<IloginStep> = ({ setStep }) => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const [email, setEmail] = useState('');
  const [otpSend, setOtpSend] = useState(false);
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const onSubmit = (data: any) => {
    setLoading(true);
    authApi
      .sendOtp(data.email)
      .then((result) => {
        setLoading(false);
        if (result) {
          setEmail(data.email);
          setOtpSend(true);
        }
      })
      .catch(() => setLoading(false));
  };

  const onVerifyOtp = (otp: number) => {
    authApi
      .verifyOtp(email, otp)
      .then((res) => {
        if (res.data) {
          setStep(1);
          dispatch(login(res.data));
        } else {
          toast.error(res.message);
        }
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  const googleSignIn = () => {
    authApi.signInWithGoogle();
  };

  return (
    <>
      {!otpSend ? (
        <div>
          <div className="flex justify-center items-center mb-10 md:mb-0">
            <h5 className="text-xl text-black font-medium">Log In</h5>
          </div>
          {/* <div className="flex flex-row items-center justify-between bg-neutralBlue2 my-6 rounded-full cursor-pointer">
            <Link
              to={process.env.REACT_APP_STUDENT_DOMAIN || '#'}
              rel="noopener noreferrer"
              className={`w-1/2 py-3 text-center rounded-3xl`}
            >
              Student
            </Link>
            <div className={`w-1/2 py-3 text-center rounded-3xl bg-primary text-white`}>Tutor</div>
          </div> */}
          <div className={`w-1/2 py-3 text-center rounded-3xl bg-primary text-white mt-4 mx-auto`}>Tutor</div>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex flex-col mt-3">
              <label htmlFor="email" className="text-lg font-normal">
                Enter Email ID
              </label>
              <input
                {...register('email', {
                  required: {
                    value: true,
                    message: 'Please Enter Your Email Address'
                  }
                })}
                type="email"
                name="email"
                placeholder="example@email.com"
                required
                className="mt-4 px-4 py-3 border border-neutralBlue1 rounded-lg"
              />
              {errors?.email && <p className="text-xs font-medium text-red-400">Please Enter Your Email Address</p>}
            </div>
            <div className="w-full mt-8">
              <Button loading={loading} block text="Proceed" role="submit" />
            </div>
          </form>
          <div className="my-4 w-full flex flex-row items-center justify-center">
            <hr className="bg-neutralBlue1 w-full" />
            <p className="px-2">OR</p>
            <hr className="bg-neutralBlue1 w-full" />
          </div>
          <button
            className="my-3 w-full flex flex-row h-11 items-center justify-center border border-neutralBlue1 rounded-md text-base"
            onClick={googleSignIn}
          >
            <img src={GOOGLE_ICON} alt="sign_in_with_google" className="h-1/2 px-2 object-contain" />
            Sign In with Google
          </button>
          <button className="my-3 w-full flex flex-row h-11 items-center justify-center border border-neutralBlue1 rounded-md text-base">
            <img src={APPLE_ICON} alt="sign_in_with_apple" className="h-1/2 px-2 object-contain" />
            Sign In with Apple
          </button>
          <div className="my-4">
            <p className="text-sm font-normal text-black leading-5 py-1">
              Your information is used to allow you to sign in securely and access your data. World O Tutor records
              certain data for security, support and reporting purposes. If you agree, World O Tutor may also use your
              information to send you marketing emails and communications. For more information view our{' '}
              <Link to="/legal/terms-conditions" className="underline hover:text-primary font-medium">
                Terms & Conditions
              </Link>
              .
            </p>
          </div>
        </div>
      ) : (
        <OtpScreen onVerify={onVerifyOtp} email={email} setOtpSend={setOtpSend} />
      )}
    </>
  );
};

export default EmailScreen;
